import { Injectable } from '@angular/core';
import { ApiService } from '../common/api.service';

@Injectable()
export class DuAnService {
  APIURL = "api/ExcuteOracle";
  constructor(private apiService: ApiService) { }
  getDanhSachDuAn() {
    var param = {
      "config": '{"namesql":"PKG_THONGKE_CHATLUONG_HT.P_LAYDS_DUAN"}',
      "para": '{}'
    };
    return this.apiService.Excute(this.APIURL, param);
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/common/duan.service.ts